import React from 'react';
import styles from './style.module.less';
import { Row, Col } from 'antd';

// const { Text } = Typography;
// const { TabPane } = Tabs;
// const { Title, Paragraph } = Typography;

const Aboutme = ({ profile_list }) => {
  // console.log('profile_list', profile_list);

  const profile = profile_list?.Profiles?.[0] || {};

  const hobbies =
    profile?.ProfileInterests?.filter(
      (item) => item?.HobbySport?.type === 'hobby'
    )
      .map((item) => item?.HobbySport?.activity)
      .join(', ') || 'Not provided';

  const sports =
    profile?.ProfileInterests?.filter(
      (item) => item?.HobbySport?.type === 'sport'
    )
      .map((item) => item?.HobbySport?.activity)
      .join(', ') || 'Not provided';

  const aboutMe = {
    profileManagedBy:
      profile?.ProfileForType?.profile_for_type || 'Not provided',
    maritalStatus: profile?.MaritalStatus?.marital_status || 'Not provided',
    age: profile?.calculated_age,
    residingLocation:
      [
        profile_list?.Profiles?.[0]?.City?.city || '',
        profile_list?.Profiles?.[0]?.State?.state || '',
        profile_list?.Profiles?.[0]?.Country?.country || ''
      ]
        .filter(Boolean) // Removes empty values
        .join(', ') || 'Not provided', // Joins non-empty values with a comma
    // height: `${profiles?.[0]?.height_ft} ft ${profiles?.[0]?.height_in} in`,
    // height: `${profile?.height_ft || '--'} ft ${profile?.height_in || '--'} in`,
    // height:
    //   profile?.height_ft || profile?.height_in
    //     ? `${profile?.height_ft || '--'} ft ${profile?.height_in || '--'} in`
    //     : 'N/A',

    height: profile?.height_cms ? `${profile?.height_cms} cm` : 'Not provided',

    weight: profile?.weight ? `${profile?.weight} kg` : 'Not provided',
    // annualIncome: profile_list?.Profiles?.[0]?.annual_income || 'N/A',
    // annualIncome: profile_list?.Profiles?.[0]?.annual_income
    //   ? Number(profile_list?.Profiles?.[0]?.annual_income).toLocaleString()
    //   : 'N/A',
    annualIncome: profile?.annual_income
      ? new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency:
            profile?.currency_code && profile?.currency_code !== 'N/A'
              ? profile?.currency_code
              : 'INR' // Default to USD if currency is 'N/A' or missing
        }).format(Number(profile?.annual_income))
      : 'Not provided',

    self_description:
      profile_list?.Profiles?.[0]?.self_description || 'Not provided',

    hobbies: hobbies,
    sports: sports,
    otherInterest: profile?.other_interests || 'Not provided',
    disability_text: profile?.is_disabled === true ? 'Yes' : 'None',
    diabled_description: profile?.diabled_description || 'Not provided'
  };
  // console.log('residingLocation', aboutMe?.residingLocation);
  return (
    <>
      <Row className={styles.aboutme}>
        <Col className={styles.colStylee}>
          <span className={styles.age}>About Me</span>
          <span className={styles.Dp}> {aboutMe?.self_description} </span>
        </Col>
      </Row>
      <Row
        gutter={24}
        className={styles.profileRow}

        // justify="space-between"
      >
        {/* Profile Managed By */}
        {/* <Col span={6} className={styles.colStyle}>
          <span className={styles.label}>Profile managed for</span>
          <div className={styles.value}> {aboutMe?.profileManagedBy} </div>
        </Col> */}

        {/* Age */}
        <Col span={8} className={styles.colStyle}>
          <span className={styles.label}>Age</span>
          <div className={styles.value}>
            {/* {' '}
            {aboutMe?.age ? `${aboutMe.age} Years` : '--'}{' '} */}
            {aboutMe?.age ? `${aboutMe.age} Years` : 'Not provided'}
          </div>
        </Col>

        {/* Height */}
        <Col span={8} className={styles.colStyle}>
          <span className={styles.label}>Height</span>
          <div className={styles.value}> {aboutMe?.height} </div>
        </Col>

        {/* Weight */}
        <Col span={8} className={styles.colStyle}>
          <span className={styles.label}>Weight</span>
          <div className={styles.value}> {aboutMe?.weight} </div>
        </Col>
      </Row>
      <Row
        gutter={24}
        className={styles.profileRow}
        style={{ paddingTop: '20px' }}
        // justify="space-between"
      >
        {/* Marital Status */}
        <Col span={8} className={styles.colStyle}>
          <span className={styles.label}>Marital Status</span>
          <div className={styles.value}> {aboutMe?.maritalStatus} </div>
        </Col>

        {/* Annual Income */}
        <Col span={8} className={styles.colStyle}>
          <span className={styles.label}>Annual Income</span>
          <div className={styles.value}> {aboutMe?.annualIncome} </div>
        </Col>

        {/* Residing Location */}
        <Col span={8} className={styles.colStyle}>
          <span className={styles.label}>Residing Location</span>
          <div className={styles.value}> {aboutMe?.residingLocation} </div>
        </Col>
      </Row>
      <Row className={styles.hobbies}>
        <Col className={styles.colStyle}>
          <span className={styles.hob}>Hobbies</span>
          <span className={styles.sport}> {aboutMe?.hobbies} </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.hob}>Sports</span>
          <span className={styles.sport}> {aboutMe?.sports} </span>
        </Col>
      </Row>

      <Row className={styles.hobbies}>
        <Col className={styles.colStyle}>
          <span className={styles.other}>Disabilities</span>
          {/* <span className={styles.sport}> {aboutMe?.disability_text} </span> */}
          <span className={styles.sport}>
            {aboutMe?.disability_text === 'Yes' && aboutMe?.diabled_description
              ? aboutMe.diabled_description
              : 'None'}
          </span>
        </Col>

        {/* {aboutMe?.disability_text === 'Yes' && (
          <Col className={styles.colStyle}>
            <span className={styles.disability}>Disabilities Description</span>
            <span className={styles.sport}>
              {aboutMe?.diabled_description || 'N/A'}
            </span>
          </Col>
        )} */}

        <Col className={styles.colStyle}>
          <span className={styles.other}>Other Interest</span>
          <span className={styles.sport}> {aboutMe?.otherInterest} </span>
        </Col>
      </Row>

      {/* <Row
        className={styles.Aboutme}
        // style={{    marginLeft: "-35px",borderBottom:"1px solid #d20b0b",color:"#d20b0b",width:"15%"}}
      >
        About Me
      </Row>
      <Row
        className={styles.sport}
        // style={{ fontFamily: 'teachers', color: '#d20b0b', fontWeight: '500' }}
      >
        {aboutMe?.self_description}
      </Row> */}
    </>
  );
};

export default Aboutme;
